import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/news/components/News/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/upcoming-events/components/UpcomingEvents/Event/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/upcoming-events/components/UpcomingEvents/List/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/components/Certifications/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ClientAreaSection"] */ "/var/src/popokgamingv2-prd/components/ClientAreaSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/pages/Home/Features/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/pages/Home/SliderSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/TrustedPartners/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/certification.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ar.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/en.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/es.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/fr.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/hi.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/pt.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ru.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/zh.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/Logo.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/og-image.png");
